import Paper from '@mui/material/Paper';
import React from 'react';

import CICImageTable from '@sophocles/views/sites/components/CICImageTable';

export default function DeviceImagesView() {
  return (
    <Paper style={{ width: '100%', height: '100%', backgroundColor: 'var(--surface-primary)', padding: '8px 12px' }}>
      <CICImageTable />
    </Paper>
  );
}
